import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import UsersTab from "../../components/admin/tabs/UsersTab";
import AdminLayout from "../../components/admin/AdminLayout";
import UserCreateForm from "../../components/admin/forms/UserCreateForm";
import CSVImportModal from "../../components/admin/components/CSVImportModal";
import ErrorMessage from "../../components/admin/components/ErrorMessage";
import useUsersData from "../../hooks/useUsersData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminUsersPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const usersData = useUsersData(user);
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh users data
    usersData.fetchUsers();
  });


  // Handle view user dashboard
  const handleViewUserDashboard = (user) => {
    navigate(`/admin/users/${user.id}/dashboard`);
  };

  // Handle update user wrapper
  const handleUpdateUserWrapper = async (userData) => {
    if (adminActions.editingUser) {
      return await adminActions.handleUpdateUser(adminActions.editingUser.id, userData);
    }
    throw new Error("Nenhum usuário sendo editado");
  };

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Gerenciar Usuários">
      <UsersTab
        users={usersData.users}
        usersPagination={usersData.usersPagination}
        loading={usersData.loading}
        error={usersData.error}
        userSearchTerm={usersData.userSearchTerm}
        setUserSearchTerm={usersData.setUserSearchTerm}
        userSearchQuery={usersData.userSearchQuery}
        fetchUsers={usersData.fetchUsers}
        onUserSearch={() => usersData.fetchUsers(1, usersData.userSearchTerm)}
        onClearUserSearch={() => {
          usersData.setUserSearchTerm("");
          usersData.setUserSearchQuery("");
          usersData.fetchUsers(1, "");
        }}
        onSearchKeyPress={(e) => {
          if (e.key === "Enter") {
            usersData.fetchUsers(1, usersData.userSearchTerm);
          }
        }}
        onEditUser={adminActions.handleEditUser}
        onViewUserDashboard={handleViewUserDashboard}
        onExportCSV={adminActions.exportUsersCSV}
        onShowCSVImport={() => adminActions.setShowCSVImport(true)}
        onShowUserForm={() => adminActions.setShowUserForm(true)}
        formatDate={(dateString) => {
          if (!dateString) return "Nunca";
          return new Date(dateString).toLocaleString("pt-BR");
        }}
      />

      {/* Modals and Forms */}
      {adminActions.showUserForm && (
        <UserCreateForm
          onClose={() => {
            adminActions.setShowUserForm(false);
            adminActions.setEditingUser(null);
          }}
          onSubmit={adminActions.editingUser ? handleUpdateUserWrapper : adminActions.handleCreateUser}
          user={adminActions.editingUser}
        />
      )}

      {adminActions.showCSVImport && (
        <CSVImportModal
          onClose={() => adminActions.setShowCSVImport(false)}
          onSubmit={adminActions.importUsersCSV}
        />
      )}

      {/* Error Message */}
      {adminActions.error && (
        <ErrorMessage
          error={adminActions.error}
          onClose={() => adminActions.setError("")}
        />
      )}
    </AdminLayout>
  );
};

export default AdminUsersPage;
